import { get } from '@styled-system/core';

export interface ThemeEvaluator {
  evaluate(theme: unknown, key: unknown): unknown;
}

const minusSignRegex = /^\s*-\s*/;

const createBaseThemeEvaluator = (scale: string) => {
  return {
    evaluate(theme: unknown, key: unknown) {
      return get(theme, `${scale}.${key}`, key);
    },
  };
};

const createSpaceThemeEvaluator = (
  spaceEvaluator: ThemeEvaluator
): ThemeEvaluator => {
  const evaluate = (theme: unknown, key: unknown) => {
    const value = spaceEvaluator.evaluate(theme, key);
    return typeof value === 'number' ? `${value}px` : value;
  };
  return {
    evaluate(theme: unknown, key: unknown) {
      if (typeof key === 'string' && minusSignRegex.test(key)) {
        const cleanKey = key.replace(minusSignRegex, '');
        const value = evaluate(theme, cleanKey);
        return `-${value}`;
      }
      return evaluate(theme, key);
    },
  };
};

export const createThemeEvaluator = (scale: string): ThemeEvaluator => {
  const baseEvaluator = createBaseThemeEvaluator(scale);
  return scale === 'space'
    ? createSpaceThemeEvaluator(baseEvaluator)
    : baseEvaluator;
};
